import type { ProductType } from '../../types';
import { ProductTypes } from '../../types';

const P100_SECURITY_ASSESSMENT_FORM_ID = 'e1c753b9-d6d7-4e6b-86a9-31c8d991f99c';
const P250_SECURITY_ASSESSMENT_FORM_ID = '56d34588-b81b-4e7a-98bb-161c96a7c0a3';
const P100_PRO_SECURITY_ASSESSMENT_FORM_ID =
  '034b06f7-66f8-4509-ab51-60bbec01ad14';
const PRIME_ONE_SECURITY_ASSESSMENT_FORM_ID =
  '3ee42a2a-576e-406f-ae40-49c5005385fa';
const PRIME_TECH_SECURITY_ASSESSMENT_FORM_ID =
  '66d34588-b81b-4e7b-98bb-161c96a7c0a4';

export const PRIME_TECH_SUPPLEMENTAL_FIRMO_FORM_ID =
  'd7e17d97-a5a5-4c0d-b872-104f261d9476';
export const CURRENT_FISCAL_YEAR_ENDING_US_FIELD_ID =
  '1dda121a-cf24-4e05-b31e-49ebec9c6fa6';
export const CURRENT_FISCAL_YEAR_ENDING_INTERNATIONAL_FIELD_ID =
  '9d263ce8-3f92-4a50-a0e3-e9e6d002bcb1';
export const SOCIAL_ENGINEERING_FORM_ID =
  '4a0cd49d-0f4c-41c0-9a20-aa202dbfb3b3';
export const ENHANCED_BUSINESS_AND_CONTINGENT_BI_FORM_ID =
  '1e370469-f89a-4dee-9da7-b71a32bc722f';
export const P250_COVERAGE_SECURITY_ASSESSMENT_FORM_ID =
  '48531689-6af0-4490-aa85-ba18ca95b153';

export const PRIME_ONE_TECH_SECURITY_ASSESSMENT_FORM_ID =
  '0f45def2-e09a-48d9-b14c-49133d5624d5';

export const PRIME_ONE_TECH_SUPPLEMENTAL_FIRMO_FORM_ID =
  '6b942344-1250-4a0d-ab87-3fff1dec62fd';

export const PRIME_ONE_TECH_DOMESTIC_REVENUE_LAST_FY_FIELD_ID =
  '8f3e4447-af80-429e-91cb-f9115a03a222';

export const PRIME_ONE_TECH_DOMESTIC_REVENUE_CURRENT_FY_FIELD_ID =
  '7d789068-2979-480c-8ff3-9dec9f73562f';

export const P_ONE_AU_ABN_FIELD_ID = '6cb7ae56-71ed-4f79-aacd-499a7af8afde';

export const PRIME_ONE_TECH_DOMESTIC_REVENUE_NEXT_FY_FIELD_ID =
  '937ce6f6-8394-4ca2-a316-6b421f3a6f1a';

export const PRIME_ONE_TECH_USA_REVENUE_LAST_FY_FIELD_ID =
  'b6cd1deb-0197-460b-92df-d809c6e796e1';

export const PRIME_ONE_TECH_USA_REVENUE_CURRENT_FY_FIELD_ID =
  '990755c3-ae86-4156-abe1-e2402e2a9a01';

export const PRIME_ONE_TECH_USA_REVENUE_NEXT_FY_FIELD_ID =
  'cc1ed620-f758-4c0a-916f-41a27b3ed895';

export const PRIME_ONE_TECH_OTHER_TERRITORY_REVENUE_LAST_FY_FIELD_ID =
  '2182859e-4089-43e0-9cff-7af009cd5795';

export const PRIME_ONE_TECH_OTHER_TERRITORY_REVENUE_CURRENT_FY_FIELD_ID =
  '6a9768ff-21d8-4aac-812b-ebb3e49abe6d';

export const PRIME_ONE_TECH_OTHER_TERRITORY_REVENUE_NEXT_FY_FIELD_ID =
  '6e7190a9-4fa4-4117-9d59-6d10f411e3fd';

export const PRIME_ONE_TECH_TOTAL_REVENUE_LAST_FY_FIELD_ID =
  '1a31044e-aeaf-4764-bad2-93578040a929';

export const PRIME_ONE_TECH_TOTAL_REVENUE_CURRENT_FY_FIELD_ID =
  'c746b27f-15cb-4e84-97f1-e05040454374';

export const PRIME_ONE_TECH_TOTAL_REVENUE_NEXT_FY_FIELD_ID =
  '13d6b492-f23c-40a8-88ea-9e1ea5c2ebe5';

export const PRIME_ONE_AU_TOTAL_REVENUE_FIELD_ID =
  '94cc06da-ac23-4963-94b1-63732fe4da07';

export const PRIME_ONE_AU_NON_AUSTRALIA_REVENUE_FIELD_ID =
  '201cb1a9-5d2a-4156-9633-6070f3d4b33f';

export const PRIME_ONE_AU_NON_AUSTRALIA_EXCLUDING_USA_REVENUE_FIELD_ID =
  'aa8ffb8b-f1b0-42a6-8783-83eb50e50d40';

export const PRIME_ONE_AU_NON_AUSTRALIA_USA_REVENUE_FIELD_ID =
  '22310990-ddb0-4ed1-b97b-0aa2a195175e';

export const PRIME_ONE_AU_REVENUE_PERCENTAGE_SPLIT_FIELD_ID =
  '05af763d-aaca-485b-864d-67e5f9fad5c3';

export const getFormIdForProduct = (productType: ProductType) => {
  switch (productType) {
    case ProductTypes.p100:
      return P100_SECURITY_ASSESSMENT_FORM_ID;
    case ProductTypes.p250:
      return P250_SECURITY_ASSESSMENT_FORM_ID;
    case ProductTypes.p100_pro:
      return P100_PRO_SECURITY_ASSESSMENT_FORM_ID;
    case ProductTypes.prime_one:
      return PRIME_ONE_SECURITY_ASSESSMENT_FORM_ID;
    case ProductTypes.prime_tech:
      return PRIME_TECH_SECURITY_ASSESSMENT_FORM_ID;
    case ProductTypes.prime_one_tech:
      return PRIME_ONE_TECH_SECURITY_ASSESSMENT_FORM_ID;
    default:
      return null;
  }
};

// TODO: Eventually get this from submission ID when moved to submissions
// get supplemental formId For Product
export const getSupplementalFormIdByProductType = (
  productType: ProductType | undefined
) => {
  switch (productType) {
    case ProductTypes.prime_tech:
      return PRIME_TECH_SUPPLEMENTAL_FIRMO_FORM_ID;
    case ProductTypes.prime_one_tech:
      return PRIME_ONE_TECH_SUPPLEMENTAL_FIRMO_FORM_ID;
    default:
      throw new Error(`Unsupported product type: ${productType}`);
  }
};
